module.exports = __webpack_public_path__ + "media/customizations/christensoncommunities/logo-8f75b326d117f4b450b59398098bd691.png";